import { DevInfo } from '../typings/dev';

export const UPDATE_DEV_INFO = 'UPDATE_DEV_INFO';
export type UPDATE_DEV_INFO = typeof UPDATE_DEV_INFO;

export interface UpdateDevInfo {
    type: UPDATE_DEV_INFO;
    devInfo: DevInfo;
}

export function updateDevInfo(devInfo: DevInfo): UpdateDevInfo {
    return {
        type: UPDATE_DEV_INFO,
        devInfo
    };
}

export type DevInfoAction = UpdateDevInfo;
